export default __webpack_public_path__ + "static/media/492.0fe58341.jpg";